'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { ComponentProps, createContext, useContext } from 'react'
import { useFormStatus } from 'react-dom'

import {
  type RumProps,
  useTrackRumAction,
} from '../../providers/real-user-monitoring'

const ButtonContext = createContext<{ isLoading?: boolean } | null>(null)
export function useButtonContext() {
  const context = useContext(ButtonContext)
  if (context === null) {
    throw new Error('useButtonContext must be used within a <BaseButton/>')
  }
  return context
}

export function BaseButton({
  /**
   * The type of the button. Manually set it to `submit` if you want to submit a form.
   *
   * @default 'button'
   */
  type = 'button',
  className,
  onClick,
  rumActionName,
  rumData,
  isLoadingOverride,
  'aria-disabled': ariaDisabled,
  ...props
}: ComponentProps<'button'> &
  RumProps & {
    /**
     * Manually set the loading state of the button.
     * Buttons with `type="submit"` will track the loading state of their form by default without this prop
     */
    isLoadingOverride?: boolean
  }) {
  const trackRumAction = useTrackRumAction()
  const formStatus = useFormStatus()
  /** A submit button will track the loading state of its form */
  const submitButtonLoading = type === 'submit' && formStatus.pending
  /** A user can override the default loading state with the `isLoading` prop */
  const isLoading = isLoadingOverride ?? submitButtonLoading
  const isAriaDisabled = ariaDisabled === true || ariaDisabled === 'true'
  const isUnavailable = isLoading || isAriaDisabled
  return (
    <ButtonContext.Provider value={{ isLoading }}>
      <button
        type={type}
        className={className}
        onClick={(event) => {
          if (isUnavailable) {
            // Prevent double firing of forms or actions or click events while this button is loading or has aria-disabled
            event.preventDefault()
            return
          }
          onClick?.(event)
          if (rumActionName) {
            trackRumAction(rumActionName, 'click', rumData)
          }
        }}
        aria-busy={isLoading ? true : undefined}
        {...props}
        aria-disabled={isUnavailable ? true : undefined}
      />
    </ButtonContext.Provider>
  )
}
